export default __webpack_public_path__ + "static/media/fund150-banner.bd28a33a.jpg";